// extracted by mini-css-extract-plugin
module.exports = {"holdingImage":"holding-image_holdingImage__gpirG","icon":"holding-image_icon__gIMrC","holdingImageUnavailable":"holding-image_holdingImageUnavailable__6jQZI"};